import { render, staticRenderFns } from "./PanelCollapseBarV2026.vue?vue&type=template&id=52db7acd&scoped=true"
import script from "./PanelCollapseBarV2026.vue?vue&type=script&lang=js"
export * from "./PanelCollapseBarV2026.vue?vue&type=script&lang=js"
import style0 from "./PanelCollapseBarV2026.vue?vue&type=style&index=0&id=52db7acd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db7acd",
  null
  
)

export default component.exports